@if (visible()) {
  @if (enBoton()) {
    <button
      type="button"
      class="ctx__boton"
      [class.es-abierto]="abierto()"
      aria-haspopup="dialog"
      [attr.aria-expanded]="abierto()"
      [attr.aria-label]="'LABELS.CONTEXT' | translate"
      [title]="'LABELS.CONTEXT' | translate"
      (click)="alternar()"
    >
      <lib-icon [name]="icono" [size]="18" />
    </button>
    @if (abierto()) {
      <div class="ctx__panel" role="dialog" [attr.aria-label]="'LABELS.CONTEXT' | translate">
        <span class="ctx__rotulo">{{ 'LABELS.CONTEXT' | translate }}</span>
        <!-- La dependencia: el chip del kit es la ficha y el disparador para cambiarla; en angosto
             el kit oculta su nombre, que va al lado completo y en varias lineas. -->
        @if (fuente(); as f) {
          <div class="ctx__fila">
            <lib-session-context />
            <span class="ctx__datos">
              <span class="ctx__fila-rotulo">{{ f.labelKey | translate }}</span>
              <span class="ctx__fila-valor ctx__fila-valor--dependencia">{{
                dependenciaActiva() ?? (f.noneKey | translate)
              }}</span>
            </span>
          </div>
        }
        <div class="ctx__fila">
          <span class="ctx__fila-ficha" aria-hidden="true">
            <lib-icon name="Calendar" [size]="15" />
          </span>
          <span class="ctx__datos">
            <span class="ctx__fila-rotulo">{{ 'LAYOUT.SYSTEM_DATE' | translate }}</span>
            <span class="ctx__fila-valor">{{ fecha() }}</span>
          </span>
        </div>
      </div>
    }
  } @else {
    @if (conDependencia()) {
      <lib-session-context />
    }
    @if (conFecha()) {
      <span
        class="ctx__fecha"
        [class.ctx__fecha--compacta]="fechaCompacta()"
        [title]="
          fechaCompacta()
            ? ('LAYOUT.SYSTEM_DATE' | translate) + ': ' + fecha()
            : ('LAYOUT.SYSTEM_DATE' | translate)
        "
        [attr.aria-label]="('LAYOUT.SYSTEM_DATE' | translate) + ': ' + fecha()"
      >
        <span class="ctx__ficha" aria-hidden="true">
          <lib-icon name="Calendar" [size]="15" />
        </span>
        @if (!fechaCompacta()) {
          <span class="ctx__valor">{{ fecha() }}</span>
        }
      </span>
    }
  }
}
